import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { UIService } from '@services';
import { CommercialStore } from '@store';

import { PartnerAccessOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-partner-access-overlay',
  templateUrl: './partner-access-overlay.component.html',
  styleUrls: ['./partner-access-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerAccessOverlayComponent {
  @Input() activePartnerAccessOverlay: PartnerAccessOverlayTypeEnum;
  @Input() installationId: number;
  @Input() gatewaySerial: string;
  readonly partnerAccessOverlayTypeEnum = PartnerAccessOverlayTypeEnum;

  constructor(private uiService: UIService, private commercialStore: CommercialStore) {}

  close(): void {
    this.commercialStore.cancelFetchingPartnerAccessList();
    this.uiService.closeActiveOverlay(this.gatewaySerial, this.installationId);
  }
}
